import { post, postJson, get, deleteApi, put } from './axios2'
 
const RESOURCE_BASE_PATH = '/paradiseAndTaskCommon';

const RESOURCE_BASE_PATH1 = '/login';

/* 积分任务 */

// 忠诚度登录
export const loginController = p => get(`${RESOURCE_BASE_PATH1}`, p);

// 积分任务和积分乐园活动公共接口
export const queryActivity = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

//结束活动
export const endEvent = id => put(`${RESOURCE_BASE_PATH}/${id}`);

//删除活动
export const deleteEvent = id => deleteApi(`${RESOURCE_BASE_PATH}/${id}`);


// /jd-hd-web/yhd/smart-card/auth/check

// 授权
export const authCheck = id => get(`/yhd/smart-card/auth/check`,id);

//小部件创建是否有效
 export const getValidActivity = p => get(`/paradiseAndTaskCommon/cardManage/getValidActivity?type=${p}`);
   
// 查询活动配置
export const getActivitySetting = p => get(`/paradiseAndTaskCommon/activitySetting/get`,p);

// 保存活动配置
export const saveActivitySetting = p => postJson(`/paradiseAndTaskCommon/activitySetting/save`,p);

//店铺渠道链接
export const customSellerLinkPage = p => postJson(`/customSellerLink/page`,p);

//添加渠道链接
export const customSellerLinkSave = p => postJson(`/customSellerLink/save`,p);

// 奖品库存预警保存/修改
export const savePrizeStockWarning = p => postJson('/show-product/stock-alert/save', p)

// 奖品库存提示查询
export const prizeStockWarningList = p => get(`/show-product/stock-alert/${p}`)

// 奖品库存预警查询（列表顶部提示）
export const prizeStockWarningText = p => get(`/show-product/stock-alert/warning-text`)

// 修改小程序所属店铺名称类型
export const updateShopNameType = p => postJson('/customSellerLink/updateShopNameType', p)
// // 查询标签
// export const getBuyerLabelByLabelName = p => get(`${RESOURCE_BASE_PATH1}/page`, p);
// // 添加标签
// export const addBuyerLabel = p => postJson(`${RESOURCE_BASE_PATH1}/`, p);
// //删除标签
// export const deleteLabelById = id => deleteApi(`${RESOURCE_BASE_PATH1}/${id}`);
// // 修改
// export const updateLabelNameById = p => put(`${RESOURCE_BASE_PATH1}/`, p);
// // 删除/批量删除标签
// export const deleteBuyerLabelById = p => post(`${RESOURCE_BASE_PATH}/deleteBuyerLabelById`, p);
// // 修改标签
// export const updateBuyerLabelNameById = p => post(`${RESOURCE_BASE_PATH}/updateBuyerLabelNameById`, p);
// // 标签管理提示
// export const getHintBuyerLabel = p => post(`${RESOURCE_BASE_PATH}/getHintBuyerLabel`, p);
// // 根据回传会员ID集, 查询公共标签
// export const getRetainLabelIds = p => post(`${RESOURCE_BASE_PATH}/getRetainLabelIds`, p);

// 分页查询活动互斥规则列表
export const activityMutexRulePage = p => postJson('/activity-mutex-rule/page', p)

// 保存活动互斥规则
export const activityMutexRuleSave = p => postJson('/activity-mutex-rule/save', p)

// 开启/关闭活动互斥规则
export const activityMutexRuleSwitch = p => postJson('/activity-mutex-rule/switch', p)

// 删除活动互斥规则
export const activityMutexRuleDelete = id => deleteApi(`/activity-mutex-rule/${id}`)

// 互斥规则详情
export const activityMutexRuleDetail = p => get(`/activity-mutex-rule/detail`,p)
